import Vue from 'vue';
import store from '../store';
import VueRouter from 'vue-router';
import Home from '../views/index.vue';

Vue.use(VueRouter);

const routes = [
	{
		path: '/gameKefu',
		name: 'gameKefu',
		component: () => import('../views/GameKefu.vue'),
		meta: { title: '客服中心' },
	},
	{
		path: '/agreements',
		name: 'agreements',
		component: () => import('../views/agreements.vue'),
		meta: { title: '协议综合' },
	},
	{
		path: '/agreement',
		name: 'agreement',
		component: () => import('../views/agreement.vue'),
		meta: { title: '单个协议' },
	},
	{
		path: '/',
		name: 'Init',
		redirect: '/home',
		component: Home,
		children: [
			{
				path: '/home',
				name: 'Home',
				component: () => import('../views/Home.vue'),
				meta: { title: '用户中心' },
			},
			{
				path: '/bindPhone',
				name: 'bindPhone',
				component: () => import('../views/BindPhone.vue'),
				meta: { title: '绑定手机号' },
			},
			{
				path: '/bindEmail',
				name: 'bindEmail',
				component: () => import('../views/BindEmail.vue'),
				meta: { title: '绑定邮箱' },
			},
			{
				path: '/bindID',
				name: 'bindID',
				component: () => import('../views/BindId.vue'),
				meta: { title: '实名认证' },
			},
			{
				path: '/findAccuont',
				name: 'findAccuont',
				component: () => import('../views/FindAccount.vue'),
				meta: { title: '验证身份' },
			},
			{
				path: '/removePhone',
				name: 'removePhone',
				component: () => import('../views/RemovePhone.vue'),
				meta: { title: '验证身份' },
			},
			{
				path: '/removeEmail',
				name: 'removeEmail',
				component: () => import('../views/RemoveEmail.vue'),
				meta: { title: '验证身份' },
			},
			{
				path: '/changePhone',
				name: 'changePhone',
				component: () => import('../views/ChangePhone.vue'),
				meta: { title: '换绑手机号' },
			},
			{
				path: '/changeEmail',
				name: 'changeEmail',
				component: () => import('../views/ChangeEmail.vue'),
				meta: { title: '换绑邮箱' },
			},
			{
				path: '/changePassword',
				name: 'changePassword',
				component: () => import('../views/ChangePsw.vue'),
				meta: { title: '修改密码' },
			},
			{
				path: '/bindScuess',
				name: 'bindScuess',
				component: () => import('../views/BindScuess.vue'),
				meta: { title: '绑定成功' },
			},
			{
				path: '/changeScuess',
				name: 'changeScuess',
				component: () => import('../views/ChangSuccess.vue'),
				meta: { title: '设置成功' },
			},
			{
				path: '/userAgreement',
				name: 'userAgreement',
				component: () => import('../views/UserAgreement.vue'),
				meta: { title: '游戏协议' },
			},
			{
				path: '/agreementInfo',
				name: 'agreementInfo',
				component: () => import('../views/AgreementInfo.vue'),
				meta: { title: '查看协议' },
			},
			{
				path: '/verifyPhone',
				name: 'verifyPhone',
				component: () => import('../views/VerifyPhone.vue'),
				meta: { title: '验证身份' },
			},
			{
				path: '/verifyaccount',
				name: 'verifyaccount',
				component: () => import('../views/Verifyaccount.vue'),
				meta: { title: '验证身份' },
			},
			{
				path: '/kefu',
				name: 'kefu',
				component: () => import('../views/kefu.vue'),
				meta: { title: '客服中心' },
			},
			{
				path: '/FAQ',
				name: 'FAQ',
				component: () => import('../views/FAQ.vue'),
				meta: { title: '常见问题' },
			},
			{
				path: '/IDScuess',
				name: 'IDScuess',
				component: () => import('../views/IDScuess.vue'),
				meta: { title: '实名认证' },
			},
			{
				path: '/privacy',
				name: 'privacy',
				component: () => import('../views/privacy.vue'),
				meta: { title: '隐私政策' },
			},
			{
				path: '/sanfangAgreement',
				name: 'sanfangAgreement',
				component: () => import('../views/sanfang.vue'),
				meta: { title: '第三方信息共享清单' },
			},
			{
				path: '/childAgreement',
				name: 'childAgreement',
				component: () => import('../views/childAgreement.vue'),
				meta: { title: '隐私政策' },
			},
			{
				path: '/CancelRule',
				name: 'CancelRule',
				component: () => import('../views/CancelRule.vue'),
				meta: { title: '注销须知' },
			},
			{
				path: '/logoffTips',
				name: 'LogoffTips',
				component: () => import('../views/LogOff/LogOffTips.vue'),
				meta: { title: '账号注销提示' },
			},
			{
				path: '/logOffAgreement',
				name: 'LogOffAgreement',
				component: () => import('../views/LogOff/LogOffAgreement.vue'),
				meta: { title: '注销协议' },
			},
			{
				path: '/logoffTerm',
				name: 'LogoffTerm',
				component: () => import('../views/LogOff/LogOffTerm.vue'),
				meta: { title: '注销条件' },
			},
			{
				path: '/safetyVerification',
				name: 'SafetyVerification',
				component: () =>
					import('../views/LogOff/SafetyVerification.vue'),
				meta: { title: '安全验证' },
			},
			{
				path: '/logOffConfirm',
				name: 'LogOffConfirm',
				component: () => import('../views/LogOff/LogOffConfirm.vue'),
				meta: { title: '注销确认' },
			},
			{
				path: '/logoffTips1',
				name: 'LogoffTips1',
				component: () => import('../views/LogOff/LogOffTips1.vue'),
				meta: { title: '注销须知' },
			},
			{
				path: '/logOffScuess',
				name: 'LogOffScuess',
				component: () => import('../views/LogOff/LogOffScuess.vue'),
				meta: { title: '账号注销申请提醒' },
			},
			{
				path: '/logOffReason',
				name: 'LogOffReason',
				component: () => import('../views/LogOff/LogOffReason.vue'),
				meta: { title: '注销原因' },
			},
			{
				path: '/permission',
				name: 'Permission',
				component: () => import('../views/Permission.vue'),
				meta: { title: '隐私权限管理' },
			},
			{
				path: '/infoList',
				name: 'InfoList',
				component: () => import('../views/InfoList.vue'),
				meta: { title: '个人信息收集清单' },
			},
			{
				path: '/loginrecord',
				name: 'Loginrecord',
				component: () => import('../views/LoginRecord.vue'),
				meta: { title: '账号登陆记录' },
			},
			{
				path: '/payrecord',
				name: 'Payrecord',
				component: () => import('../views/PayRecord.vue'),
				meta: { title: '游戏充值记录' },
			},
			{
				path: '/linkweb',
				name: 'Linkweb',
				component: () => import('../views/Linkweb.vue'),
				meta: { title: '' },
			},
		],
	},
];

const router = new VueRouter({
	// mode: 'history',
	base: process.env.BASE_URL,
	routes,
});
router.beforeEach((to, from, next) => {
	//beforeEach是router的钩子函数，在进入路由前执行
	if (to.meta.title) {
		//判断是否有标题
		document.title = to.meta.title;
		store.dispatch('info/setWebtitle', to.meta.title);
	}
	next(); //执行进入路由，如果不写就不会进入目标页
});
export default router;
